<template>
    <div class="odd:bg-white even:bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt v-if="$slots.title || title" class="text-sm leading-5 font-medium text-gray-500">
            <slot name="title">
                {{ title }}
            </slot>
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0"
            :class="$slots.title || title ? 'sm:col-span-2' : 'sm:col-span-3'">
            <slot>
                {{ content ? content : '-' }}
            </slot>
        </dd>
    </div>
</template>


<script>
export default {
    props: {
        title: [String, Number],
        content: [String, Number]
    }
}
</script>
